export const MIN_INTERVAL_DAYS = 1

export type CouponCampaignFormData = {
  campaignName: string
  couponDescription: string
  couponTitle: string
  intervalDays: number | string
  startAt: string
}

export type CouponCampaignPayload = {
  active: boolean
  campaignName: string
  couponDescription: string
  couponTitle: string
  createdBy: string
  intervalDays: number
  nextRunAt: Date
  recipientUserIds: string[]
}

export const parseIntervalDays = (value: unknown): number => {
  const parsed = Math.floor(Number(value))
  return Number.isFinite(parsed) && parsed >= MIN_INTERVAL_DAYS ? parsed : MIN_INTERVAL_DAYS
}

export const validateCouponCampaignForm = (
  formData: CouponCampaignFormData,
  recipientUserIds: string[],
): string[] => {
  const errors: string[] = []

  if (!formData.campaignName?.trim()) {
    errors.push("Campaign name is required.")
  }
  if (!formData.couponTitle?.trim()) {
    errors.push("Coupon title is required.")
  }
  if (!formData.startAt) {
    errors.push("Start date is required.")
  } else if (Number.isNaN(new Date(formData.startAt).getTime())) {
    errors.push("Start date is invalid.")
  }
  if (Number(formData.intervalDays) < MIN_INTERVAL_DAYS) {
    errors.push(`Interval must be at least ${MIN_INTERVAL_DAYS} day.`)
  }
  if (!recipientUserIds.length) {
    errors.push("Select at least one recipient.")
  }

  return errors
}

export const buildCouponCampaignPayload = ({
  createdBy,
  formData,
  recipientUserIds,
}: {
  createdBy: string
  formData: CouponCampaignFormData
  recipientUserIds: string[]
}): CouponCampaignPayload => ({
  active: true,
  campaignName: formData.campaignName.trim(),
  couponDescription: formData.couponDescription?.trim() || "",
  couponTitle: formData.couponTitle.trim(),
  createdBy,
  intervalDays: parseIntervalDays(formData.intervalDays),
  nextRunAt: new Date(formData.startAt),
  recipientUserIds,
})
